module.exports = __webpack_public_path__ + "img/Expert-Led Learning.ef15c9f0.png";